import { Autocomplete, Box, Button, FormControlLabel, IconButton, Radio, RadioGroup, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import DeleteIcon from '@mui/icons-material/Delete';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { COMMON_STYLE } from '../../../../Utility/Constants';
import { AddCircle } from '@material-ui/icons';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

const illnessState = {
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  selectedRadio: 'illness',
  // illness State
  illnessData: [],
  illnessSugesstion: [],
  dupIllnessData: '[]',
  // allergy State
  allergyData: [],
  allergySugesstion: [],
  dupAllergyData: '[]',
  loadScreen: false
}

const UmaDocIllness = React.forwardRef((data, ref) => {
  const listVal = data
  const [illness, setIllness] = useState(illnessState)
  const changedRef = useRef(false)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - SYSTEMIC ILLNESS`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - SYSTEMIC ILLNESS`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performIllnessAction: () => {
      if (
        (JSON.stringify(illness.illnessData) !== illness.dupIllnessData) ||
        (JSON.stringify(illness.allergyData) !== illness.dupAllergyData)
      ) {
        postSystemicIllnessData()
      }
    }
  }))

  const apiCalls = async () => {
    await getIllnessSuggData()
    await getAllergySuggData()
    await getSystemicIllnessData()
  }

  const getIllnessSuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ILLNESS_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response?.data?.status === 'success') {
        setIllness((prev) => ({ ...prev, illnessSugesstion: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getAllergySuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_ALLERGY_SUGG + '?doctor_id=' + data?.props?.doctorID)
      if (response?.data?.status === 'success') {
        setIllness((prev) => ({ ...prev, allergySugesstion: response?.data?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getSystemicIllnessData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_SYSTEMIC_ILLNESS
        + '?patient_id=' + data?.props?.patient_id + '&appointment_id=' + data?.props?.appointment_id + '&doctor_id=' + data?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let illnessList = response?.data?.data?.illness
        let allergyList = response?.data?.data?.drug_allergy
        let illnessObj = { id: null, illness_name: "", year: '', month: '', treatment: "" }
        let allergyObj = { id: null, allergy_name: "", comments: "", no_of_years: '', no_of_months: '' }
        setIllness((prev) => ({
          ...prev,
          illnessData: illnessList?.length > 0 ? [...illnessList, illnessObj] : [illnessObj],
          dupIllnessData: illnessList?.length > 0 ? JSON.stringify([...illnessList, illnessObj]) : JSON.stringify([illnessObj]),
          allergyData: allergyList?.length > 0 ? [...allergyList, allergyObj] : [allergyObj],
          dupAllergyData: allergyList?.length > 0 ? JSON.stringify([...allergyList, allergyObj]) : JSON.stringify([allergyObj]),
          loadScreen: true
        }))
        data.patientHasAllergy(allergyList || [])
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postSystemicIllnessData = async () => {
    try {
      let illnessList = illness.illnessData?.filter(item => item?.illness_name)
      let allergyList = illness.allergyData?.filter(item => item?.allergy_name)
      let list = {
        illness: illnessList,
        drug_allergy: allergyList,
        appointment_id: data?.props?.appointment_id
      }
      const response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_SYSTEMIC_ILLNESS)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getSystemicIllnessData()
        changedRef.current = false
      }
    } catch (error) {
      changedRef.current = false
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteSystemicIllnessData = async (item, index, type) => {
    try {
      if (item?.id) {
        let list = {
          illness_id: type === 'illness' ? item?.id : null,
          allergy_id: type === 'illness' ? null : item?.id,
          doctor_id: listVal?.props?.doctorID
        }
        const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_SYSTEMIC_ILLNESS, list)
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getSystemicIllnessData()
        }
      } else {
        let illnessData = [...illness.illnessData]
        let allergyData = [...illness.allergyData]
        setIllness((prev) => {
          if (type === 'illness') {
            if (index !== (illness.illnessData?.length - 1)) {
              illnessData?.splice(index, 1)
            } else {
              illnessData[index] = {
                ...illnessData[index], id: null, illness_name: "", year: '', month: '', treatment: ""
              }
            }
          } else {
            if (index !== (illness.allergyData?.length - 1)) {
              allergyData?.splice(index, 1)
            } else {
              allergyData[index] = {
                ...allergyData[index], id: null, allergy_name: "", comments: "", no_of_years: '', no_of_months: ''
              }
            }
          }
          return { ...prev, illnessData, allergyData }
        })
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const onChangeHandler = (newValue, key, index, type) => {
    try {
      setIllness((prev) => {
        let illnessData = [...illness.illnessData]
        let allergyData = [...illness.allergyData]
        switch (key) {
          case 'illness_name':
            illnessData[index] = { ...illnessData[index], illness_name: newValue }
            if (newValue !== '' && index === illnessData.length - 1) {
              let obj = { id: null, illness_name: "", year: '', month: '', treatment: "" };
              illnessData.push(obj)
              changedRef.current = true
            }
            break;
          case 'allergy_name':
            allergyData[index] = { ...allergyData[index], allergy_name: newValue }
            if (newValue !== '' && index === allergyData.length - 1) {
              let obj = { id: null, allergy_name: "", comments: "", no_of_years: '', no_of_months: '' };
              allergyData?.push(obj)
              changedRef.current = true
            }
            break;
          case 'no_of_months':
            if (CommonValidation.numberOnly(newValue) || newValue === '') {
              allergyData[index] = { ...allergyData[index], no_of_months: newValue }
              changedRef.current = true
            }
            break;
          case 'no_of_years':
            if (CommonValidation.numberOnly(newValue) || newValue === '') {
              allergyData[index] = { ...allergyData[index], no_of_years: newValue }
              changedRef.current = true
            }
            break;
          case 'month':
            if (CommonValidation.numberOnly(newValue) || newValue === '') {
              illnessData[index] = { ...illnessData[index], month: newValue }
              changedRef.current = true
            }
            break;
          case 'year':
            if (CommonValidation.numberOnly(newValue) || newValue === '') {
              illnessData[index] = { ...illnessData[index], year: newValue }
              changedRef.current = true
            }
            break;
          default:
            if (type === 'illness') {
              illnessData[index] = { ...illnessData[index], [key]: newValue }
            } else {
              allergyData[index] = { ...allergyData[index], [key]: newValue }
            }
            changedRef.current = true
            break;
        }
        return { ...prev, allergyData, illnessData }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const textBox = (names, values, index, label, type, width) => {
    try {
      return (
        <TextField
          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
          autoComplete='off'
          size='small'
          value={values}
          sx={{ width: width ? width : '4dvw' }}
          onChange={(e) => {
            let value = e.target.value
            if (CommonValidation.numberOnly(value) && value <= COMMON_STYLE.DATE_LIMIT || value === '') {
              onChangeHandler(value, names, index, type)
            }
          }}
          InputProps={{
            emed_tid: names,
            style: { height: COMMON_STYLE.HEIGHT }
          }}
          placeholder={label}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderIllnessScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Illness</TableCell>
                <TableCell className='doc_notes_tbl_header'>Duration</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {illness?.illnessData?.length > 0 ? illness?.illnessData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '11dvw' }}
                        value={item?.illness_name}
                        options={illness.illnessSugesstion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'illness_name', index, 'illness') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'illness_name', index, 'illness') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Illness'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'ill_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'}>
                        {textBox('year', item.year, index, 'Y', 'illness')}
                        {textBox('month', item.month, index, 'M', 'illness')}
                      </Box>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          autoComplete='off'
                          size='small'
                          multiline
                          maxRows={5}
                          value={item?.treatment}
                          sx={{ width: '13dvw' }}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS) {
                              onChangeHandler(value, 'treatment', index, 'illness')
                            }
                          }}
                          InputProps={{
                            emed_tid: 'ill_trt',
                            style: item?.treatment ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          placeholder={'Comments'}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteSystemicIllnessData(item, index, 'illness') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderAllergyScreen = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Allergy</TableCell>
                <TableCell className='doc_notes_tbl_header'>Duration</TableCell>
                <TableCell className='doc_notes_tbl_header'>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {illness?.allergyData?.length > 0 ? illness?.allergyData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Autocomplete
                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                        freeSolo
                        clearIcon
                        size='small'
                        sx={{ width: '11dvw' }}
                        value={item?.allergy_name}
                        options={illness.allergySugesstion}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                        onChange={(e, newValue) => { onChangeHandler(newValue, 'allergy_name', index, 'allergy') }}
                        onInputChange={(e, newValue) => { onChangeHandler(newValue, 'allergy_name', index, 'allergy') }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Enter Allergy'
                            InputProps={{
                              ...params.InputProps, emed_tid: 'alg_name',
                              style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'}>
                        {textBox('no_of_years', item.no_of_years, index, 'Y', 'allergy')}
                        {textBox('no_of_months', item.no_of_months, index, 'M', 'allergy')}
                      </Box>
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <TextField
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          autoComplete='off'
                          size='small'
                          multiline
                          maxRows={5}
                          value={item?.comments}
                          sx={{ width: '13dvw' }}
                          onChange={(e) => {
                            let { value } = e.target
                            if (value?.length <= COMMON_STYLE.CHAR_LIMIT_COMMENTS) {
                              onChangeHandler(value, 'comments', index, 'allergy')
                            }
                          }}
                          InputProps={{
                            emed_tid: 'alg_cmts',
                            style: item?.comments ? { maxHeight: COMMON_STYLE.MAX_HEIGHT } : { height: COMMON_STYLE.HEIGHT }
                          }}
                          placeholder={'Comments'}
                        />
                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='alg_dlt'
                          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                          onClick={() => { deleteSystemicIllnessData(item, index, 'allergy') }}
                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apiCalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'}>
            <Typography className='doc_notes_header_card_font'>Systemic Illness</Typography>
            {/* <Box component={'div'} display={'flex'}>
              <RadioGroup
                row
                emed_tid='ill_radio'
                value={illness.selectedRadio}
                onChange={(e) => { setIllness((prev) => ({ ...prev, selectedRadio: e.target.value })) }}
              >
                <FormControlLabel value="illness" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Illness</Typography>} />
                <FormControlLabel value="allergy" control={<Radio size='small' />} label={<Typography className='doc_notes_header_card_font'>Allergy</Typography>} />
              </RadioGroup>
            </Box> */}
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Illness</Typography>
              <Box component={'div'}>{renderIllnessScreen()}</Box>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Typography className='doc_notes_header_card_font' mb={'0.5rem'}>Allergy</Typography>
              <Box component={'div'}>{renderAllergyScreen()}</Box>
            </Box>
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDocIllness